<template>
  <div class="product-i-post">
    <span
      class="product-i-post__link"
      :class="{
        'product-i-post__link_disabled':
          (isPair && !isPairSelected) ||
          (product?.price?.quantity == 2 && isPair && isPairSelected),
      }"
      @click="isOpen = true"
    >
      <svg class="product-i-post__icon"><use xlink:href="#svg-thunder"></use></svg>
      <DefLink>
        {{ messages.fastDelivery }}
      </DefLink>
    </span>
    <DefSlideModal :active="isOpen" @close="isOpen = false">
      <template #title>
        {{ messages.fastDelivery }}
      </template>
      <IPostModal :product="product" :messages="messages" />
    </DefSlideModal>
  </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue';
import { useStore } from '@store';
import DefLink from '@components/Def/DefLink/DefLink.vue';
import DefSlideModal from '@components/Def/DefSlideModal/DefSlideModal.vue';
import IPostModal from '@components/Product/ProductIPost/IPostModal.vue';

const { product, messages } = defineProps(['product', 'messages']);
const {
  state: { product: storeProduct },
} = useStore();
const isOpen = ref(false);

const isPair = computed(() => storeProduct?.data?.product?.isPair);
const isPairSelected = computed(() => storeProduct?.data?.isPairSelected);
</script>

<script>
export default {
  name: 'ProductIPost',
};
</script>

<style lang="scss" scoped>
.product-i-post {
  &__link {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    &_disabled {
      pointer-events: none;
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
  &__icon {
    width: 18px;
    height: 18px;
    margin-right: 6px;
    fill: var(--background-black);
  }
}
</style>
